import { debounce } from "lodash";
import { useState } from "react";

export const useSearchFilterTranslations = () => {
  const [searchValue, setSearchValue] = useState<string>("");

  const onSearchTranslation = debounce((value: string) => {
    setSearchValue(value);
  }, 500);

  return {
    onSearchTranslation: onSearchTranslation,
    searchValue,
    setSearchValue,
    isLoadingSearch: false,
  };
};
